import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function ContentSection() {
  return <section className="w-full bg-[#f5f5f5] py-16 md:py-20 lg:py-24 px-4" data-id="element-44">
      <div className="max-w-7xl mx-auto" data-id="element-45">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 text-center mb-8" data-id="element-46">
          ¿Qué incluye la formación{' '}
          <span className="text-[#c41e3a]" data-id="element-47">Método Barber Pro</span>?
        </h2>
        <div className="w-32 h-1 bg-[#c41e3a] mx-auto mb-20" data-id="element-48"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16" data-id="element-49">
          {/* Parte I */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300 relative" data-id="element-50">
            {/* Número grande */}
            <div className="absolute top-6 right-6 text-8xl font-black text-gray-200" data-id="element-51">
              1
            </div>

            {/* Imagen de Parte I */}
            <div className="mb-8 flex justify-center relative z-10" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/7KK6PQzZ9Eh7SteCr4XUUb/parte1.png" alt="Parte I - Fundamentos y Estructura Profesional" className="w-48 h-auto rounded-lg shadow-md" data-id="element-53" />
            </div>
            <div className="flex items-center gap-4 mb-6" data-id="element-54">
              <BookOpenIcon className="w-12 h-12 text-[#c41e3a]" aria-hidden="true" data-id="element-55" />
              <h3 className="text-3xl font-black text-gray-900" data-id="element-56">PARTE I</h3>
            </div>
            <h4 className="text-2xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-57">
              Fundamentos y Estructura Profesional
            </h4>
            <p className="text-gray-700 leading-relaxed text-xl" data-id="element-58">
              Mentalidad profesional, diagnóstico, lectura de cabeza y
              arquitectura del corte.
            </p>
          </div>

          {/* Parte II */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300 relative" data-id="element-59">
            {/* Número grande */}
            <div className="absolute top-6 right-6 text-8xl font-black text-gray-200" data-id="element-60">
              2
            </div>

            {/* Imagen de Parte II */}
            <div className="mb-8 flex justify-center relative z-10" data-id="element-61">
              <img src="https://cdn.magicpatterns.com/uploads/cF1oV7reWEE8ki6yfeFVxq/parte2.png" alt="Parte II - Técnica y Aplicación Real" className="w-48 h-auto rounded-lg shadow-md" data-id="element-62" />
            </div>
            <div className="flex items-center gap-4 mb-6" data-id="element-63">
              <BookOpenIcon className="w-12 h-12 text-[#c41e3a]" aria-hidden="true" data-id="element-64" />
              <h3 className="text-3xl font-black text-gray-900" data-id="element-65">PARTE II</h3>
            </div>
            <h4 className="text-2xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-66">
              Técnica y Aplicación Real
            </h4>
            <p className="text-gray-700 leading-relaxed text-xl" data-id="element-67">
              Grados, distribución, control de forma y aplicación práctica con
              apoyo visual.
            </p>
          </div>

          {/* Parte III */}
          <div className="bg-white rounded-lg p-12 shadow-lg border-4 border-gray-300 relative" data-id="element-68">
            {/* Número grande */}
            <div className="absolute top-6 right-6 text-8xl font-black text-gray-200" data-id="element-69">
              3
            </div>

            {/* Imagen de Parte III */}
            <div className="mb-8 flex justify-center relative z-10" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/mdc15jyJnHAQyAajxhes1B/parte3.png" alt="Parte III - Negocio y Profesionalización" className="w-48 h-auto rounded-lg shadow-md" data-id="element-71" />
            </div>
            <div className="flex items-center gap-4 mb-6" data-id="element-72">
              <BookOpenIcon className="w-12 h-12 text-[#c41e3a]" aria-hidden="true" data-id="element-73" />
              <h3 className="text-3xl font-black text-gray-900" data-id="element-74">PARTE III</h3>
            </div>
            <h4 className="text-2xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-75">
              Negocio y Profesionalización
            </h4>
            <p className="text-gray-700 leading-relaxed text-xl" data-id="element-76">
              Precios, clientes, marca personal y sistema de trabajo rentable.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-77">
          <p className="text-gray-700 text-2xl font-bold italic max-w-3xl mx-auto leading-relaxed" data-id="element-78">
            👉 Todo el contenido se presenta en formato ebook profesional,
            pensado como manual de estudio y consulta.
          </p>
        </div>
      </div>
    </section>;
}